const generateCustomCSSGradient = (color1, color2, angle = null) => {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const isTabletOrMobile = vw < 980;
    const degrees = Math.atan(vh / vw) * (180 / Math.PI);
    return `linear-gradient(${isTabletOrMobile ? "-" : ""}${angle ? angle : degrees}deg, ${color1} 0%, ${color1} 50%, ${color2} 50%, ${color2} 100%)`;
};

export default generateCustomCSSGradient;